module.exports = __webpack_public_path__ + "static/img/b4.bef0c18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial2/b4.jpg
// module id = uciB
// module chunks = 14